/**
 * The way back from Ember games' Gas Me Up into a conversation (2026-10-30
 * Riley; the game lives in Oriscen/ember-games, games/types, at /gas-me-up —
 * renamed from its first name the same day so the six types never read as a
 * label Ember puts on its own people). Ember sits
 * beside the game's composer and under its cards; a tap on it opens a portal
 * to Ember, which lands on /talk?mode=chat&gasmeup=<door>&type=<type> —
 * carrying which door and, from a card, which of the six types it shows,
 * never a word anyone typed — and the line the conversation opens on is
 * written here from those two.
 *
 * The doors (ember-games games/types/web/EmberBuddy.tsx):
 *   home     on the game's front page and My cards
 *   chat     in the middle of the four questions
 *   card     under the person's own card
 *   friend   under someone else's card (the type is theirs)
 *   not_now  the reading found them not in a joking mood, and made no card
 *
 * The types and their rivals are the game's, every season's (games/types/content.js
 * TYPES); a new season's types are added here too.
 */

export const GAS_ME_UP_HANDOFF_DOORS = Object.freeze(['home', 'chat', 'card', 'friend', 'not_now']);

/** Each type as it is said, and its natural enemy. */
export const GAS_ME_UP_HANDOFF_TYPES = Object.freeze({
  golden_retriever: { name: 'a Golden Retriever', rival: 'a Black Cat' },
  black_cat: { name: 'a Black Cat', rival: 'a Golden Retriever' },
  main_character: { name: 'a Main Character', rival: 'an NPC' },
  npc: { name: 'an NPC', rival: 'a Main Character' },
  group_chat_mom: { name: 'a Group Chat Mom', rival: 'a Chaos Goblin' },
  chaos_goblin: { name: 'a Chaos Goblin', rival: 'a Group Chat Mom' },
});

/** The first line of the conversation for a Gas Me Up link, or '' when the link names no door we know. */
export function gasMeUpTalkLine(door, type) {
  const d = String(door || '');
  if (!GAS_ME_UP_HANDOFF_DOORS.includes(d)) return '';
  const t = String(type || '');
  // Own keys only, as in yard-handoff.js: 'constructor' is not a type.
  const known = Object.prototype.hasOwnProperty.call(GAS_ME_UP_HANDOFF_TYPES, t) ? GAS_ME_UP_HANDOFF_TYPES[t] : null;
  switch (d) {
    case 'home':
      return 'I was on Gas Me Up and I’d rather just talk.';
    case 'chat':
      return 'I was answering your Gas Me Up questions and I’d rather just talk.';
    case 'card':
      return known
        ? `You gassed me up as ${known.name}, and my natural enemy is ${known.rival}. Is that really me?`
        : 'I just got my Gas Me Up card. Is that really me?';
    case 'friend':
      return known
        ? `A friend of mine got ${known.name} on Gas Me Up. I want to figure out what I am.`
        : 'A friend sent me their Gas Me Up card. I want to figure out what I am.';
    case 'not_now':
      return 'I wasn’t in the mood for a quiz. I’d rather just talk.';
    default:
      return '';
  }
}
